import type { PropsWithChildren } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface RightContainerProps {
  className?: string;
}

export const RightContainer = ({
  children,
  className,
}: PropsWithChildren<RightContainerProps>) => (
  <div
    className={classNames("flex w-full items-center justify-end", className)}
  >
    {children}
  </div>
);
